import {atom} from "recoil";

/**
 * 휴가 결재 상신함 문서 상태
 * @type {RecoilState<number>}
 */
export const sentDocTotalCount = atom({
    key: "sentDocTotalCount"
    , default: 0
})